import { render, staticRenderFns } from "./nut-home.vue?vue&type=template&id=feb66868&scoped=true&"
import script from "./nut-home.vue?vue&type=script&lang=js&"
export * from "./nut-home.vue?vue&type=script&lang=js&"
import style0 from "./nut-home.vue?vue&type=style&index=0&id=feb66868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb66868",
  null
  
)

export default component.exports